<template>
  <div class="container-fluid animate__animated animate__fadeIn animate__faster">
    <div class="row mt-2">
      <!-- Header -->
      <div class="col-md-12text-center">
        <img
          :src="header"
          class="img-fluid w-100">
      </div>
      <!-- Header Contents -->
      <div class="col-md-4 p-5">
        <h1>YOU'RE INVITED</h1>
        <p>The 2026 Lancaster Buying Show will allow you to meet face-to-face with manufacturers to see new and exciting products hitting the market. Get inspired by discussing ideas and best business practices with other retailers during the seminars, show and events. Lancaster’s Buying Show will be offering tremendous deals to give you a competitive edge to grow your business in the coming year.</p>
      </div>
      <div class="col-md-4">
        <video
          :src="video"
          controls
          controlsList="nodownload"
          autoplay="true"
          class="img-fluid mt-5"/>
      </div>
      <div class="col-md-4 p-5">
        <h4>Quick Links</h4>
        <ul
          class="no-dot"
          style="line-height: 33px;">
          <li>
            <a
              :href="registrationLink"
              target="_blank">
              Register Today
            </a>
          </li>
          <li>
            <a
              :href="hotelReservationLink"
              target="_blank">
              Host Hotel Reservations
            </a>
          </li>
          <li>
            <a
              :href="floorPlan"
              target="_blank">
              Exhibitor Listing & Floor Plan
            </a>
          </li>
          <li>
            <a
              :href="prizeRules"
              target="_blank">
              Prize Rules
            </a>
          </li>
          <!-- <li>
            <a
              :href="canada ? cadShowBook : usShowBook"
              target="_blank">
              Show Book
            </a>
          </li>
          <li>
            <a
              :href="canada ? cadPreShow : usPreShow"
              target="_blank'">
              Pre Show Ordering Sample
            </a>
          </li>
          <li>
            <a
              :href="canada ? cadEarlyBirds : usEarlyBirds"
              target="_blank">
              Early Birds Teasers
            </a>
          </li> -->
          <!-- <li v-if="vShowAllowed">
            <router-link to="/virtual_show">
              ENTER SHOW PORTAL
            </router-link>
          </li> -->
        </ul>
      </div>
    </div>
    <!-- Event Schedule -->
    <div class="row">
      <div
        class="mt-5 p-2"
        style="background: #efefef;">
        <div class="row">
          <div class="col-md-4 mt-5 text-center">
            <img
              :src="eventSchedule"
              class="img-fluid"
              style="max-height: 200px;">
            <img
              :src="packetPickup"
              class="img-fluid my-5"
              style="max-height: 200px;">
          </div>
          <div class="col-md-8">
            <div class="row">
              <div class="col-md-12 py-3">
                <h3 style="color: #12313E;">FEBRUARY 6 - 7 • ORLANDO, FL</h3>
              </div>
              <div class="col-md-6">
                <strong style="color: #12313E;">FRIDAY, FEBRUARY 6th</strong>
                <ul class="event-times">
                  <li>9:00am - 1:00pm • Customer Pre-Packet Pickup</li>
                  <li>
                    <strong>9:30am - 5:30pm • Lancaster Buying Show</strong>
                  </li>
                  <li>9:30am - 11:30am • Early Bird Specials</li>
                  <li>12:30pm - 2:00pm • Show Floor Refreshments</li>
                  <li>6:15pm - 6:30pm • Buses depart the Renaissance to SeaWorld®</li>
                  <li>6:45pm - 7:00pm • SeaWorld® Dolphin Adventure Show</li>
                  <li>7:00pm - 8:30pm • Dinner at SeaWorld®</li>
                  <li>8:30pm - 10:00pm • SeaWorld® Penguin Trek & Kraken Roller Coaster</li>
                  <small class="text-muted">*When checking in at the Lancaster Registration Desk, please see your packet for show schedule locations.</small>
                </ul>
              </div>
              <div class="col-md-6">
                <strong style="color: #12313E;">SATURDAY, FEBRUARY 7th</strong>
                <ul class="event-times">
                  <li>7:00am - 8:30am • Breakfast</li>
                  <li>
                    <strong>8:00am - 12:00pm • Lancaster Buying Show</strong>
                  </li>
                  <li>8:00am - 10:00am • Early Bird Specials</li>
                  <li>11:45am - 12:00pm • Prize Books are to be turned in</li>
                  <li>12:00pm - 1:30pm • Lunch & Prize Drawings</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Paralax -->
     <div
      class="text-center text-white"
      :style="paralaxStyle">
      <h2>YOU'RE NOT GOING TO WANT TO MISS OUT</h2>
     </div>
    <!-- Buying Show Deals -->
    <div class="row">
      <div class="col-md-12 text-center my-5">
        <h1 style="font-weight: 900; letter-spacing: 10px;">BUYING SHOW DEALS</h1>
        <template v-if="!canada">
          <h5 style="font-weight: 500;">EXTENDED PAYMENT TERMS</h5>
          <p
            style="max-width: 50em; margin: 0 auto;"
            class="py-2">
            <span>Show attendees can take advantage of extended payment terms of up to 60 days. Please note that some vendors may offer standard Net 30 Day terms, which will be indicated in the show book.</span>
          </p>
        </template>
        <!-- Dates -->
        <div>
          <strong class="d-block">Pre-Show Ordering Dates: 1/26/2026 - 2/5/2026</strong>
          <strong class="d-block">2026 Lancaster Buying Show Dates: 2/6/2026 - 2/7/2026</strong>
        </div>
      </div>
      <!-- Circles -->
      <div class="container">
        <div class="row mb-5">
          <div class="col text-center">
            <a
              :href="canada ? cadShowBook : showBook"
              target="_blank">
              <img
                :src="circle1"
                style="max-height: 18em; max-width: 18em;"
                class="img-fluid circle p-5"> 
            </a>
          </div>
          <div
            v-if="!canada"
            class="col text-center">
            <a
              :href="preShow"
              target="_blank">
              <img
                :src="circle2"
                style="max-height: 18em; max-width: 18em;"
                class="img-fluid circle p-5">
            </a>
          </div>
          <div
            v-if="!canada"
            class="col text-center">
            <a
              :href="earlyBirds"
              target="_blank">
              <img
                :src="circle3"
                style="max-height: 18em; max-width: 18em;"
                class="img-fluid circle p-5">
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- Cash Spiffs -->
    <div
      class="row position-relative mt-5"
      style="background: #f8961f;">
      <div
        class="col-md-12 py-5 text-center text-light">
        <img
          :src="cashSpiffs"
          class="img-fluid penguin-absolute">
        <div
          class="mt-5"
          style="max-width: 620px; margin: 0 auto;">
          <div>Spiffs are offered by many of our exhibitors as an incentive to attend the show and to focus your buying on particular products, however you must attend the 2026 event to earn them.</div>
          <div>*Canadian Exchange Rates Apply</div>
        </div>
      </div>
    </div>
    <!-- Reimbursement -->
    <div
      class="row py-5 text-light"
      style="background: #024059;">
      <div class="col-md-4 p-5 text-center">
        <h1>Reimbursement Qualifications</h1>
      </div>
      <div class="col-md-4 px-5">
        <div class="text-center">
          <img
            :src="airplaneIcon"
            class="img-fluid"
            style="max-height: 65px;">
        </div>
        <div class="text-center">
          <strong>AIRLINE REIMBURSEMENT</strong>
        </div>
        <div class="mt-2">
          Purchases of $8,000 USD or more qualify for a travel reimbursement equal to 3% of your show purchases (up to $750 USD per ship-to location).
        </div>
      </div>
      <div class="col-md-4 px-5">
        <div class="text-center">
          <img
            :src="hotelIcon"
            class="img-fluid"
            style="max-height: 65px;">
          </div>
          <div class="text-center">
            <strong>Hotel REIMBURSEMENT</strong>
          </div>
          <div class="mt-2">
            <ul>
              <li>Purchases of $8,000 - $9,999 USD One Night Reimbursed*</li>
              <li>Purchases of $10,000+ USD Two Nights Reimbursed*</li>
            </ul>
            <div>
              *Room, tax and resort fee, based on thegroup rate.
            </div>
          </div>
      </div>
    </div>
    <!-- Image Slider -->
    <div class="row my-5 d-none d-sm-block">
      <div id="carouselId" class="carousel slide" data-bs-ride="carousel">
        <div class="carousel-inner" role="listbox">
          <div
            v-for="(s,i) in slides"
            class="carousel-item"
            :class="{active: i == 0}">
            <div class="row">
              <div
                v-for="img in s"
                :key="img"
                class="col">
                <img
                  :src="img"
                  class="img-fluid">
              </div>
            </div>
          </div>
        </div>
        <button
          class="carousel-control-prev"
          type="button"
          data-bs-target="#carouselId"
          data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button
          class="carousel-control-next"
          type="button"
          data-bs-target="#carouselId"
          data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
      <div class="col-md-12 text-center mt-3 d-none d-lg-block">
        <strong>PICTURES FROM THE 2025 LANCASTER FL BUYING SHOW</strong>
      </div>
    </div>
    <!-- Prize Banner -->
    <div class="row">
      <div class="col-md-6 p-0 text-center">
        <img
          :src="prizes1"
          class="img-fluid p-0">
      </div>
      <div class="col-md-6 p-0 text-center">
        <img
          :src="prizes2"
          class="img-fluid p-0">
      </div>
      <div class="col-12 text-center mt-5">
        <a
          :href="prizeRules"
          target="_blank"
          class="btn btn-lg btn-primary">
          Prize Rules
        </a>
      </div>
    </div>
    <!-- Seminars   -->
    <!-- <div class="row my-5">
      <div class="col-md-6 text-center align-content-center">
        <img
          :src="seminar"
          class="img-fluid">
      </div>
      <div class="col-md-6">
        <div class="my-3">
          <h2 style="letter-spacing: 5px;">SEMINAR</h2>
          <h6>FRIDAY, FEBRUARY 6 • 9:30am - 11:30am</h6>
        </div>
        <div class="mt-3">
          <div>
            <strong>Your possibilities just expanded!</strong>
          </div>
          <span>Be the first to see NEW & INNOVATIVE products presented by some of Lancaster’s suppliers. Learn from the experts at this complimentary seminar to see if these products are a fit for your market and receive exclusive deals just by attending. Sign-up today to gain access to the Innovate to Elevate Seminar before the Buying Show opens.</span>
        </div>
      </div>
    </div> -->
    <!-- Join US -->
    <div class="row p-5">
      <div class="col-md-6 text-center p-0">
        <img
          :src="joinUsLeft"
          class="img-fluid p-0">
      </div>
      <div class="col-md-6 text-center p-0">
        <img
          :src="joinUsRight"
          class="img-fluid p-0">
      </div>
    </div>
    <!-- Host Hotel -->
    <div
      class="row d-flex align-items-end p-5"
      style="background: #dff0ee;">
      <div class="col-md-12 text-center">
        <div>
          <h3 style="letter-spacing: 5px;">SHOW LOCATION & HOST HOTEL</h3>
        </div>
        <a
          :href="hotelReservationLink"
          target="_blank"
          class="btn btn-outline-dark my-3">
          HOTEL RESERVATIONS
        </a> 
      </div>
      <!-- Hotel Details -->
      <!-- Hotel Images -->
      <div class="col-md-4 text-center">
        <div style="min-height: 150px;">
          <h4 class="event-orange">LOCATION</h4>
          <div>
            <a href="https://www.marriott.com/en-us/hotels/mcosr-renaissance-orlando-at-seaworld/overview/?msockid=05b0370b7499657631af211e7512649c">Renaissance Orlando at SeaWorld®</a>
          </div>
          <div>
            6677 Sea Harbor Drive
            <br>
            Orlando, FL 32821
            <br>
            Phone <a href="tel:1-800-327-6677">(800)-327-6677</a>
          </div>
        </div>
        <div class="bg-white">
          <img
            :src="hotel1"
            class="img-fluid hotel-img">
        </div>
      </div>
      <div class="col-md-4 text-center">
        <div style="min-height: 150px;">
          <h4 class="event-orange">ROOMS</h4>
          <div>Single/Double: $209 USD rate plus a $20 USD per night resort fee. To qualify for this rate, you must make your room reservations by January 16, 2026 (based on availability).*</div>
        </div>
        <div class="bg-white">
          <img
            :src="hotel2"
            class="img-fluid hotel-img">
        </div>
      </div>
      <div class="col-md-4 text-center">
        <div style="min-height: 150px;">
          <h4 class="event-orange">PARKING</h4>
          <div>Lancaster customers will receive complimentary self-parking for registered overnight guests. Daily self-parking rate for non-registered guests is $40 USD.</div>
        </div>
        <div class="bg-white">
          <img
            :src="hotel3"
            class="img-fluid hotel-img">
        </div>
      </div>
      <div class="p-5">
        <small>The Renaissance Orlando at SeaWorld has everything you love about Florida, all in one location. The resort is within walking distance of SeaWorld® and all of Orlando’s most celebrated attractions are just a quick shuttle ride away. This family-friendly resort offers so much to enjoy. Be captivated by the soaring atrium. Embrace the light-filled comforts of guest rooms and suites. Lounge poolside with a tropical drink while the kids play in the water park, with water slides and a toddler play area. For deeper relaxation head to the Wellness Spa for a variety of treatments. Savor every moment with your choice of locally sourced cuisine and artistic cocktails at their restaurants and bars. This resort lets you enjoy the best of Orlando, all in one place.</small>
      </div>
      <div>
        <small>
          <strong>
            *Resort Fee:&nbsp;
          </strong>
          Rooms rates will be subject to a non-commissionable daily resort fee, REDUCED to $20 USD (currently $45 USD per room per night, plus applicable taxes) in effect at the time of check in.
        </small>
      </div>
    </div>  
  </div>
</template>

<script>
  import Terms from './Terms.vue'
  export default {
    data(){
      return{
        video: 'https://lancaster-video.s3.amazonaws.com/2026_FL_Buying_Show_Intro_1.mp4',
        header: 'https://merit-production.s3.amazonaws.com/lanEstore/events/fl_2026/eStore_Header_Image_2026_FL_Show.png',
        eventSchedule: 'https://merit-production.s3.amazonaws.com/lanEstore/events/fl_2026/Event_Schedule_Penguin.png',
        packetPickup: 'https://merit-production.s3.amazonaws.com/lanEstore/events/fl_2026/Schedule_Thursday_Customer_Packet_Pickup.png',
        airplaneIcon: 'https://merit-production.s3.amazonaws.com/lanEstore/events/fl_2026/Airplane_Icon.png',
        hotelIcon: 'https://merit-production.s3.amazonaws.com/lanEstore/events/fl_2026/Hotel_Icon.png',
        circle1: 'https://merit-production.s3.amazonaws.com/lanEstore/events/fl_2026/Show_Book_Circle_Button.png',
        circle2: 'https://merit-production.s3.amazonaws.com/lanEstore/events/fl_2026/Pre_Show_Circle_Button.png',
        circle3: 'https://merit-production.s3.amazonaws.com/lanEstore/events/fl_2026/Early_Bird_Circle_Button.png',
        seminar: 'https://merit-production.s3.amazonaws.com/lanEstore/events/fl_2026/Innovate_to_Elevate_Seminar.png',
        hotel1: 'https://merit-production.s3.amazonaws.com/lanEstore/events/fl_2026/Renaissance_Hotel_Left.png',
        hotel2: 'https://merit-production.s3.amazonaws.com/lanEstore/events/fl_2026/Renaissance_Hotel_Middle.png',
        hotel3: 'https://merit-production.s3.amazonaws.com/lanEstore/events/fl_2026/Renaissance_Hotel_Right.png',
        registrationLink: 'https://forms.office.com/Pages/ResponsePage.aspx?id=fPEa6ncEKE2w_7aFUxWX4mIBSbk4s_5IuljxmitwdpJUNEM0S1FQRDlKNFM1N0NYWjVQSkMxODYzTiQlQCN0PWcu',
        hotelReservationLink: 'https://book.passkey.com/event/50895514/owner/210/home',
        cashSpiffs: 'https://merit-production.s3.amazonaws.com/lanEstore/events/fl_2026/Cash_Spiffs_Penguin.png',
        prizes1: 'https://merit-production.s3.amazonaws.com/lanEstore/events/fl_2026/Prize_Section_Left_Side.png',
        prizes2: 'https://merit-production.s3.amazonaws.com/lanEstore/events/fl_2026/Prize_Section_Right_Side.png',
        joinUsLeft: 'https://merit-production.s3.amazonaws.com/lanEstore/events/fl_2026/SeaWorld_Orlando_Exrcusion_Left_Side.png',
        joinUsRight: 'https://merit-production.s3.amazonaws.com/lanEstore/events/fl_2026/SeaWorld_Orlando_Exrcusion_Right_Side.png',
        floorPlan: 'https://merit-production.s3.amazonaws.com/lanEstore/events/fl_2026/2026_Lancaster-FL-Show_Floor-Plan_Listing.pdf',
        showBook: 'https://merit-production.s3.amazonaws.com/lanEstore/events/fl_2026/2026-FL-Lancaster-Show-Book_includes-revisions.pdf',
        cadShowBook: 'https://merit-production.s3.amazonaws.com/lanEstore/events/fl_2026/2026_CA_FL_Buying_Show_Book.pdf',
        earlyBirds: 'https://merit-production.s3.amazonaws.com/lanEstore/events/fl_2026/2026-FL-Lancaster-Show-Book-EB_Front_Section.pdf',
        preShow: 'https://merit-production.s3.amazonaws.com/lanEstore/events/fl_2026/Pre-Show-Ordering_2026-FL-Lancaster-Show-Book.pdf',
        prizeRules: 'https://merit-production.s3.amazonaws.com/lanEstore/events/fl_2026/2026_FL_Buying_Show_Official_Contest_Rules.pdf',
        paralaxStyle: {
          backgroundImage: 'url(https://merit-production.s3.amazonaws.com/lanEstore/events/fl_2026/Lancaster_00040.jpg)',
          backgroundRepeat: 'no-repeat',
          height: '15em',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          alignContent: 'center',
          textShadow: '2px 2px 5px black'
        },
      }
    },
    components:{
      Terms
    },
    computed:{
      sessionCompany(){return this.$store.getters.sessionCompany},
      slides(){
        let slides = []
        for(let i=1; i<=35; i++){
          slides.push(`https://merit-production.s3.amazonaws.com/lanEstore/events/fl_2026/slide_pictures/Lancaster${i}.jpg`)
        }
        return _.chunk(slides, 5)
      },
      canada(){return this.sessionCompany == 'Lancaster Canada'},
      vShowAllowed(){return this.$store.getters.vShowAllowed}
    }
  }
</script>

<style scoped>
  video{
    width: 100%;
  }
  .no-dot{
    list-style-type: none;
    padding: 0px;
  }
  ul{
    padding: 0px;
  }
  .poplar{
    color: black;
    font-size:50px;
    font-weight: 900;
  }
  .bg-gray{
    background: #e6e7e8;
  }
  .event-times{
    line-height:38px;
    list-style-type: none;
  }
  /* .circle{
    height: fit-content;
    width: fit-content;
    padding: 30px;
    margin: 0 auto;
    border: 3px solid #f89422;
    border-radius: 50%;
    margin-top: 20px;
  }
  .circle span{
    color: #f89422;
    font-size: 25px;
  } */
  .special{
    font-family: POPLARSTD;
    font-size: 50px !important;
  }
  .circle:hover{
    cursor:pointer;
    transform: scale(1.05);
    transition: 150ms ease-in;
    /* background: #f89422;
    text-shadow: 1px 1px 10px whitesmoke; */
  }
  .black-wrapper{
    background: rgb(18, 44, 61, .8);
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    align-items: center;
    display: flex;
    justify-content: center;
  }
  .slider-img{
    object-fit: cover;
    height: 200px;
    width: 100%;
    min-width: 100px;
  }
  .gray-gradient{
    background: linear-gradient(to bottom, white, #e6e7e8 )
  }
  .circle-img{
    object-fit: cover;
    object-position: center;
    border-radius: 50%;
    padding: 30px;
    overflow: hidden;
  }
  @media(max-width: 1500px){
    .circle-img{
      width: 250px;
      height: 250px;
    }
  }
  @media(min-width: 1501px){
    .circle-img{
      width: 400px;
      height: 400px;
    }
  }
  .hotel-img{
    height: 300px;
    width: 400px;
    object-fit: cover;
    object-position: center;
    padding: 10px;
  }
  .circle-link{
    text-decoration: none;
    transition: filter 150ms ease-in;
  }
  .circle-link:hover{
    filter: drop-shadow(2px 4px 6px black) hue-rotate(45deg);
  }
  .carousel-control-next{
    width: 5%;
    opacity: 1;
  }
  .carousel-control-prev{
    width: 5%;
    opacity: 1;
  }
  .reimbursement{
    position: absolute;
    max-width: 45vw;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .circle-text{
    list-style-type: none;
    font-weight: 900;
    font-size: 20px;
    padding: 20px 0px;
  }
  .circle-text li{
    padding: .5rem;
  }
  .suit{
    height: 15px;
    width: 15px;
  }
  .penguin-absolute{
    max-height: 190px;
    position: absolute;
    top: -7em;
    margin: 0 auto;
    left: 50%;
    transform: translateX(-50%);
  }
  .event-orange{
    color: #EE7F37;
  }
</style>